import API from "shared/services/Api";
import { IPatientSearchResponse, IAttendedConsultationsResponse, IPatientInfoResponse } from "shared/types/Patient";
import { IDentistHistoryResponse } from "shared/types/DentistHistory";

export const searchPatients = async (
  userId: string,
  search: string
): Promise<IPatientSearchResponse> =>
  API.get(`/oc/patients/search?id=${userId}&search=${encodeURIComponent(search)}`);

export const getDentistHistory = async (
  userId: string,
  patientId: number
): Promise<IDentistHistoryResponse> =>
  API.get(`/oc/patients/${patientId}/dentist-history?id=${userId}`);

export const getAttendedConsultations = async (
  userId: string,
  patientId: number
): Promise<IAttendedConsultationsResponse> =>
  API.get(`/oc/patients/${patientId}/attended-consultations?id=${userId}`);

export const getPatientInfo = async (
  userId: string,
  patientId: number
): Promise<IPatientInfoResponse> =>
  API.get(`/oc/patients/${patientId}/info?id=${userId}`);

